import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import swal from "sweetalert";

export const createDiplomaSubscriptionApi = createAsyncThunk(
  "subscription/diplomas/create",
  async (subscriptionData) => {
    const tokenData = await JSON.parse(localStorage.getItem("userData")).token;
    const request = await fetch(
      `${process.env.REACT_APP_VERSEL_API}/api/user/subscripers/addSubscriptions/diploma`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${tokenData}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          studentId: subscriptionData.studentId,
          diplomaId: subscriptionData.diplomaId,
        }),
      }
    )
      .then((response) => response.json())
      .then((result) => {
        return result;
      })
      .catch((error) => {
        formatError(error);
        return error;
      });

    return request;
  }
);

function formatError(errorResponse) {
  swal("Oops", `${errorResponse}`, "error");
}
const createSubscriptionDiplomasSlicer = createSlice({
  name: "createDiplomaSubscription",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(createDiplomaSubscriptionApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createDiplomaSubscriptionApi.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload.message === "subscription added successfully") {
        state.data = action.payload.data;
      } else {
        state.error = action.payload.message;
        formatError(state.error);
      }
    });
    builder.addCase(createDiplomaSubscriptionApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
      formatError(state.error);
    });
  },
});

export default createSubscriptionDiplomasSlicer.reducer;
